import type { TextVariables } from '~shared/rundown/rundown'

import { rundownApi } from '../../../axios'
import { apiErrorHandler } from '../../../utils/api-error-handler.ts'
import type {
  GetVariablesParams,
  CreateVariableParams,
  GetVariableParams,
  UpdateVariableParams,
  DeleteVariableParams,
} from '../model/params'

const buildBase = (rundownId: string) => `/${rundownId}/text-variables`

export const getVariables = async ({ rundownId }: GetVariablesParams) => {
  return apiErrorHandler(rundownApi.get<TextVariables>(buildBase(rundownId)))
}

export const createVariable = async ({
  rundownId,
  payload,
}: CreateVariableParams) => {
  return apiErrorHandler(rundownApi.post(buildBase(rundownId), payload))
}

export const getVariable = async ({
  rundownId,
  variableKey,
}: GetVariableParams) => {
  return apiErrorHandler(
    rundownApi.get(`${buildBase(rundownId)}/${variableKey}`),
    {
      toast: false,
    },
  )
}

export const updateVariable = async ({
  rundownId,
  variableKey,
  payload,
}: UpdateVariableParams) => {
  return apiErrorHandler(
    rundownApi.put(`${buildBase(rundownId)}/${variableKey}`, payload),
  )
}

export const deleteVariable = async ({
  rundownId,
  variableKey,
}: DeleteVariableParams) => {
  return apiErrorHandler(
    rundownApi.delete(`${buildBase(rundownId)}/${variableKey}`),
  )
}
